/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {reportChargebackInfo} from '../api'

export const useMutationReportChargebackInfo = createReactQueryMutationHook('reportChargebackInfo', reportChargebackInfo)
